import { render, staticRenderFns } from "./EnableTest.vue?vue&type=template&id=24962d17&"
import script from "./EnableTest.vue?vue&type=script&lang=js&"
export * from "./EnableTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports